<template lang="html">
  <section class="login">
    <div class="wrapper d-flex align-items-center auth login-full-bg">
      <div class="row w-100">
        <div class="col-lg-6 mx-auto">
          <div class="auth-form-dark text-left p-5">
            <h2>Login</h2>
            <h4 class="font-weight-light">Welcome to eTakeAway</h4>
            <form class="pt-5">
              <form>
                <div class="form-group">
                  <label>Username</label>
                  <input type="text" class="form-control" placeholder="Username" v-model="credentials.username">
                  <i class="mdi mdi-account"></i>
                </div>
                <div class="form-group">
                  <label>Password</label>
                  <input type="password" class="form-control" placeholder="Password" v-model="credentials.password">
                  <i class="mdi mdi-eye"></i>
                </div>
                <div class="mt-5">
                  <b-button class="btn btn-block btn-warning btn-lg font-weight-medium" v-on:click="handlebtnLogin">Login</b-button>
                </div>
                <div class="mt-3 text-center">
                  <a href="#" class="auth-link text-white">Forgot password?</a>
                </div>
              </form>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
import { mapState } from'vuex'

export default {
  name: 'login',
  data() {
      return {
          credentials: {
              username: '',
              password: ''
          }
      }
  },
  methods: {
    async handlebtnLogin() {
      await this.$store.dispatch('login/authenticateAction', this.credentials);
      this.$router.push('/');
    }
  }
}
</script>

<style scoped lang="scss">

</style>
